var map = {
	"./aiPdfTranslate/Comparison/1.jpg": 20160,
	"./aiPdfTranslate/Comparison/2.jpg": 94127,
	"./aiPdfTranslate/Comparison/3.jpg": 34098,
	"./aiPdfTranslate/Comparison/4.jpg": 41345,
	"./aiPdfTranslate/Comparison/5.jpg": 67748,
	"./aiPdfTranslate/Comparison/6.jpg": 93971,
	"./aiPdfTranslate/Hero/1.jpg": 99155,
	"./aiPdfTranslate/Hero/2.jpg": 4996,
	"./aiPdfTranslate/Hero/3.jpg": 83041,
	"./aiPdfTranslate/Hero/4.jpg": 57554,
	"./aiPdfTranslate/Hero/5.jpg": 29935,
	"./aiPdfTranslate/Hero/6.jpg": 16320,
	"./aiPdfTranslate/Hero/7.jpg": 67453,
	"./aiPdfTranslate/Hero/8.jpg": 93182,
	"./aiPdfTranslate/Hero/9.jpg": 41019,
	"./aiPdfTranslate/TemplateShowcase/1.jpg": 18686,
	"./aiPdfTranslate/TemplateShowcase/2.jpg": 92393,
	"./aiPdfTranslate/TemplateShowcase/3.jpg": 47020,
	"./aiPdfTranslate/TemplateShowcase/4.jpg": 1367,
	"./aiPdfTranslate/TemplateShowcase/5.jpg": 90554,
	"./aiPdfTranslate/TemplateShowcase/6.jpg": 13157,
	"./aiPdfTranslate/TemplateShowcase/7.jpg": 50792,
	"./aiPdfTranslate/TemplateShowcase/8.jpg": 55283,
	"./aiPdfTranslator/card-bg.png": 49755,
	"./aiPdfTranslator/check-mark.png": 70875,
	"./aiPdfTranslator/free-use-arrow.png": 12965,
	"./aiPdfTranslator/install-arrow.png": 52908,
	"./aiPdfTranslator/introduces/1-icon.svg": 18021,
	"./aiPdfTranslator/introduces/1.png": 62959,
	"./aiPdfTranslator/introduces/2-icon.svg": 1276,
	"./aiPdfTranslator/introduces/2.png": 40500,
	"./aiPdfTranslator/introduces/3-icon.svg": 42151,
	"./aiPdfTranslator/introduces/3.png": 61629,
	"./aiPdfTranslator/introduces/4-icon.png": 94134,
	"./aiPdfTranslator/introduces/4.png": 68834,
	"./aiPdfTranslator/title-unline.png": 3553,
	"./contact/contact-bg.png": 12463,
	"./contact/fill-global_star.svg": 61473,
	"./contact/icon__1.png": 84573,
	"./contact/icon__2.png": 806,
	"./contact/icon__3.png": 85903,
	"./contact/icon__title.png": 84758,
	"./download_icon.png": 16850,
	"./download_save.png": 3794,
	"./fonts/Hind-Medium.ttf": 25828,
	"./fonts/Hind-Regular.ttf": 37395,
	"./fonts/Hind-SemiBold.ttf": 95682,
	"./help/amazon.png": 68718,
	"./help/bg.png": 30735,
	"./help/bg_guide.png": 93638,
	"./help/bg_video.png": 36083,
	"./help/facebook.png": 76926,
	"./help/icon__arrow.png": 29248,
	"./help/icon__done.png": 74307,
	"./help/icon__gift_free.png": 87808,
	"./help/icon__light.png": 49175,
	"./help/icon__pin.png": 80342,
	"./help/icon__pro.png": 88306,
	"./help/icon__pro_check.png": 93607,
	"./help/icon_arrow_light.png": 25554,
	"./help/icon_gift.png": 35864,
	"./help/icon_newuser_bg.png": 1541,
	"./help/icon_pin_title.png": 56922,
	"./help/icon_rocket.png": 5038,
	"./help/icon_site_arrow.png": 76429,
	"./help/icon_use_start.png": 35384,
	"./help/icon_wiki.png": 35874,
	"./help/icon_youtube.png": 70991,
	"./help/ins.png": 13696,
	"./help/tiktok.png": 10292,
	"./help/twitter.png": 79857,
	"./help/wiki.png": 40182,
	"./home/ai-assistant-icon-1-1.png": 12537,
	"./home/ai-assistant-icon-2.png": 97268,
	"./home/ai-assistant-icon-3.png": 18397,
	"./home/ai-assistant-icon-4.png": 73026,
	"./home/ai-assistant-icon-5.png": 47179,
	"./home/ai-assistant-icon-6.png": 33360,
	"./home/ai-assistant-pic-1-1.png": 97028,
	"./home/ai-assistant-pic-1.png": 60638,
	"./home/ai-assistant-pic-2-1.png": 93047,
	"./home/ai-assistant-pic-2.png": 27989,
	"./home/ai-assistant-pic-3-1.png": 16818,
	"./home/ai-assistant-pic-3.png": 58892,
	"./home/ai-assistant-tab-pic-1.png": 98435,
	"./home/ai-assistant-tab-tag-1.png": 52912,
	"./home/ai-assistant-tab-tag-2.png": 40555,
	"./home/ai-assistant-tab-tag-3.png": 3074,
	"./home/avatar/avatar1.png": 80288,
	"./home/avatar/avatar2.png": 58619,
	"./home/avatar/avatar3.png": 27442,
	"./home/avatar/avatar4.png": 48653,
	"./home/avatar/avatar5.png": 78404,
	"./home/avatar/avatar6.png": 31615,
	"./home/banner-top-1.png": 55964,
	"./home/banner-top-2.png": 14071,
	"./home/bg__how-it-work.png": 41187,
	"./home/btn-star.png": 30555,
	"./home/hiw-1-1.png": 20684,
	"./home/hiw-1.png": 58262,
	"./home/hiw-2-1.png": 46591,
	"./home/hiw-2.png": 39885,
	"./home/hiw-3-1.png": 98490,
	"./home/hiw-3.png": 99940,
	"./home/hiw-4-1.png": 55021,
	"./home/hiw-4.png": 81595,
	"./home/last-block-bg-1.png": 40386,
	"./home/last-block-bg.png": 78812,
	"./home/pdf-translate-icon-1.png": 19303,
	"./home/pdf-translate-icon-2.png": 50828,
	"./home/pdf-translate-icon-3.png": 33717,
	"./home/pdf-translate-pic.png": 84184,
	"./home/top-bg-1.png": 35679,
	"./home/top-bg-2.png": 81028,
	"./home/top-bg-3.png": 20973,
	"./home/user-reviews-bg.png": 34883,
	"./home/user-reviews-divider.png": 17855,
	"./home/video-img-1.mp4": 90080,
	"./home/video-web-1.mp4": 22139,
	"./icon__arrow-primary-color.png": 46033,
	"./icon__arrow_down.png": 73975,
	"./icon__arrow_up.png": 47068,
	"./icon__card-delete.png": 67159,
	"./icon__card-link.png": 84370,
	"./icon__close-with-border.png": 84849,
	"./icon__close.png": 42297,
	"./icon__default-favicon.png": 58905,
	"./icon__empty.png": 86014,
	"./icon__favorite-empty.png": 74789,
	"./icon__key.png": 66216,
	"./icon__lang-empty.png": 10677,
	"./icon__right-arrow.png": 23831,
	"./icon__search.png": 63885,
	"./icon__stick.png": 32341,
	"./icon__tab-favorite-empty.png": 47399,
	"./icon__tab-favorite.png": 17459,
	"./icon__tab-pdf-empty.png": 29473,
	"./icon__tab-pdf.png": 69869,
	"./login/bg__login-modal.png": 12926,
	"./login/bg__login.png": 24958,
	"./login/icon__google.png": 78446,
	"./logo-without-text.png": 53868,
	"./logo.png": 33153,
	"./newUser/bg__alert-v1.png": 38221,
	"./newUser/icon__countdown.png": 87222,
	"./newUser/icon__star.png": 26327,
	"./option/icon__close-with-border.png": 69349,
	"./option/icon__search.png": 42705,
	"./pdf/alltext.png": 72909,
	"./pdf/bg__ai-assistant-video.png": 80653,
	"./pdf/bg__download.png": 85126,
	"./pdf/bg__loading.png": 73108,
	"./pdf/bg__pdf-video-v1.png": 16652,
	"./pdf/curve-v1.png": 94432,
	"./pdf/curve.png": 64860,
	"./pdf/dingdang.png": 91613,
	"./pdf/download-pdf-icon-1.png": 3974,
	"./pdf/download-pdf-icon-2.png": 45213,
	"./pdf/edit.png": 80745,
	"./pdf/ext.png": 56472,
	"./pdf/hamburger.png": 92404,
	"./pdf/hover.png": 89279,
	"./pdf/icon__history-close.png": 57861,
	"./pdf/icon__history-delete.png": 72568,
	"./pdf/icon__large-pdf.png": 14314,
	"./pdf/icon__loading.png": 68414,
	"./pdf/icon__notification.png": 48233,
	"./pdf/icon__purple-arrow.png": 56514,
	"./pdf/icon__puzzle-fragment.png": 48571,
	"./pdf/icon__translate.png": 59028,
	"./pdf/image-book.png": 94418,
	"./pdf/image-search.png": 2777,
	"./pdf/info-icon.png": 98099,
	"./pdf/loading-f.png": 73532,
	"./pdf/loading-icon-v1.png": 52757,
	"./pdf/loading-icon.png": 72295,
	"./pdf/mouse-left.png": 93604,
	"./pdf/next-page.png": 80268,
	"./pdf/paper-icon.png": 10461,
	"./pdf/pdf-icon.png": 8881,
	"./pdf/pdf-logo.png": 93083,
	"./pdf/pdf-upload.png": 91717,
	"./pdf/preview-page.png": 16325,
	"./pdf/rect.png": 56139,
	"./pdf/report-icon.png": 31353,
	"./pdf/right.png": 4227,
	"./pdf/share-icon.png": 56516,
	"./pdf/share-light.png": 54667,
	"./pdf/share-progress.png": 23918,
	"./pdf/share-star.png": 70135,
	"./pdf/share-underline.png": 15683,
	"./pdf/share.png": 87408,
	"./pdf/switch-icon.png": 25403,
	"./pdf/tip11.png": 59372,
	"./pdf/tip2-v1.png": 12158,
	"./pdf/tip3.png": 24147,
	"./pdf/tool-history.png": 17948,
	"./pdf/tool-upload.png": 87609,
	"./pdf/upgrade-bg.png": 12041,
	"./pdf/upload-btn-icon.png": 56675,
	"./pdf/upload-file.png": 39355,
	"./pdf/upload-icon.png": 53962,
	"./pdf/upload-rocket.png": 44177,
	"./pdf/web.png": 1047,
	"./pdf/zoom-in-icon.png": 60070,
	"./pdf/zoom-out-icon.png": 81185,
	"./pricing/bg__1.png": 41249,
	"./pricing/bg__2.png": 83818,
	"./pricing/bg__count.png": 77757,
	"./pricing/bg__discount-v1.png": 78997,
	"./pricing/bg__discount.png": 24327,
	"./pricing/bg__fail.png": 68846,
	"./pricing/bg__pdf-limited.png": 26499,
	"./pricing/bg__qa-top.png": 88970,
	"./pricing/bg__qa.png": 96604,
	"./pricing/bg__succ.png": 11284,
	"./pricing/icon__bell.png": 75131,
	"./pricing/icon__chat-btn.png": 76857,
	"./pricing/icon__countdown.png": 95427,
	"./pricing/icon__enterprise.png": 63677,
	"./pricing/icon__fail.png": 7188,
	"./pricing/icon__fireworks.png": 57972,
	"./pricing/icon__free.png": 30594,
	"./pricing/icon__hot.png": 69079,
	"./pricing/icon__pro.png": 28515,
	"./pricing/icon__prov.png": 24445,
	"./pricing/icon__rockets.png": 58373,
	"./pricing/icon__succ.png": 95034,
	"./pricing/limited-time-offer.png": 19016,
	"./pricing/new-user-text.png": 99803,
	"./print_icon.png": 89087,
	"./trialModal/bg-1.png": 61595,
	"./trialModal/bg2.png": 4679,
	"./trialModal/bg3.png": 86366,
	"./trialModal/bg4.png": 27377,
	"./trialModal/chat.png": 9746,
	"./trialModal/focus.png": 93234,
	"./trialModal/gift.gif": 71813,
	"./trialModal/gift.png": 40806,
	"./trialModal/gift2.gif": 32805,
	"./trialModal/hover.png": 20580,
	"./trialModal/img.png": 93831,
	"./trialModal/memo.png": 17346,
	"./trialModal/pdf.png": 57252,
	"./trialModal/price-bg.png": 61649,
	"./trialModal/pro-hot.png": 68825,
	"./trialModal/pro-trial-text-bg.png": 60488,
	"./trialModal/prov-hot.png": 70903,
	"./trialModal/prov-trial-text-bg.png": 33158,
	"./trialModal/realtime.png": 2111,
	"./trialModal/select.png": 1060,
	"./trialModal/text-bg-1.png": 64903,
	"./trialModal/text-bg.png": 27525,
	"./trialModal/token.png": 91261,
	"./trialModal/video-summary.png": 18412,
	"./trialModal/video.png": 56671,
	"./trialModal/web-summary.png": 1487,
	"./trialModal/web.png": 94720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;